import app from "nystem";
import { Wrapper } from "nystem-components";

const FloatCurrency = ({ model, value }) =>
  value ? (
    <Wrapper className={model.className} renderAs={model.renderAs}>
      {new Intl.NumberFormat(app.settings.lang, { style: "currency", currency: "SEK", maximumFractionDigits: 0 }).format(
        value,
      )}
    </Wrapper>
  ) : null;

export default FloatCurrency;
